var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { BOverlay, BCol, BCard } from 'bootstrap-vue';
import debounce from 'lodash/debounce';
import { getSheetPrice } from 'ts/modules/pricing';
let UpsellSheetProduct = class UpsellSheetProduct extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.pricing = {
            base_unit_price: '0.00',
            ex_vat_base_unit_price: '0.00',
            unit_price: '0.00',
            total_price: '0.00',
            unit_discount: '0.00',
            total_discount: '0.00'
        };
        this.priceIncrease = '0.00';
        this.debouncedCalcPrice = debounce(this.calculatePriceIncrease, 350);
        this.debouncedGetPrice = debounce(this.getPrice, 350);
    }
    get href() {
        var _a, _b, _c;
        let params = new URLSearchParams();
        params.set('widthMM', this.size.width.toString());
        params.set('lengthMM', this.size.length.toString());
        return `/diy-framing/accessories/${(_b = (_a = this.product.category) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.slug}/${(_c = this.product.meta) === null || _c === void 0 ? void 0 : _c.slug}?${params.toString()}`;
    }
    calculatePriceIncrease() {
        this.priceIncrease = (parseFloat(this.pricing.unit_price.replace(',', '')) - parseFloat(this.basePrice.replace(',', ''))).toFixed(2);
    }
    getPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.product.sku || !this.quantity) {
                return;
            }
            this.loading = true;
            try {
                // Get the price for this product
                this.pricing = yield getSheetPrice(this.product.sku, this.size, false, null, this.quantity);
            }
            catch (e) {
                console.error(e);
            }
            this.loading = false;
        });
    }
    mounted() {
        this.getPrice();
    }
};
__decorate([
    Prop(Object)
], UpsellSheetProduct.prototype, "size", void 0);
__decorate([
    Prop(Object)
], UpsellSheetProduct.prototype, "product", void 0);
__decorate([
    Prop(String)
], UpsellSheetProduct.prototype, "basePrice", void 0);
__decorate([
    Prop(Number)
], UpsellSheetProduct.prototype, "quantity", void 0);
__decorate([
    Watch('pricing.unit_price'),
    Watch('basePrice')
], UpsellSheetProduct.prototype, "debouncedCalcPrice", void 0);
__decorate([
    Watch('size', { deep: true }),
    Watch('quantity')
], UpsellSheetProduct.prototype, "debouncedGetPrice", void 0);
UpsellSheetProduct = __decorate([
    Component({
        components: {
            BOverlay, BCol, BCard
        }
    })
], UpsellSheetProduct);
export default UpsellSheetProduct;
